export const SEARCH = {
  SIMULATED_LATENCY_MS: 200,
  MAX_RESULTS_PRODUCTS: 100,
  MAX_RESULTS_BLOG: 50,
  RESULTS_LIMIT: 5,
  MIN_LENGTH: 2,
} as const;
